import AreaChooser from "./AreaChooser.vue";

export default AreaChooser;
